import {chatsAdapter} from "../slices/chats";

export const {
    selectById: chatById,
    selectAll: chatsAll,
} = chatsAdapter.getSelectors((state: any)=> state.chats);
